import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Platform from './Platform';
import { TabPaneStyles } from '../styles';
import { BingIcon, BlueIcon, GoogleIcon, MetaIcon, TikTokIcon } from 'assets/icons';

const PLATFORM_ORDER = ['PMAX', 'Search', 'Meta', 'TikTok', 'Bing', 'Blue'];

const ICONS = {
  PMAX: GoogleIcon,
  Search: GoogleIcon,
  Meta: MetaIcon,
  TikTok: TikTokIcon,
  // LinkedIn: LinkedInIcon,
  Bing: BingIcon,
  Blue: BlueIcon,
};

const TabPanePlatforms = ({ setStatus, platforms }) => {
  const { t: translate } = useTranslation();

  const sortedPlatforms = [...platforms].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <TabPaneStyles>
      <span>{translate('Active Platforms')}</span>
      <div className="d-flex flex-column gap-2">
        {platforms &&
          sortedPlatforms.map((platform) => (
            <Platform
              key={platform.id}
              id={platform.id}
              platform={platform.name}
              active={platform.enabled}
              icon={ICONS[platform.name]}
              setStatus={setStatus}
            />
          ))}
      </div>
    </TabPaneStyles>
  );
};

TabPanePlatforms.propTypes = {
  setStatus: PropTypes.func.isRequired,
  platforms: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default TabPanePlatforms;
